import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class AdminShopifyStoresNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('shopify-store');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
